import { useQuery } from '@apollo/react-hooks';
import { useEffect, useState } from 'react';
import VALIDATE_GOOGLE_OAUTH_CREDENTIALS from '../../../../GraphQl/Queries/VALIDATE_GOOGLE_OAUTH_CREDENTIALS';

const PaidSearchGoogleOAuthHandler = (orgId) => {
  const [googleOAuthStatus, setGoogleOAuthStatus] = useState();

  const { data, refetch } = useQuery(VALIDATE_GOOGLE_OAUTH_CREDENTIALS, {
    variables: {
      name: orgId,
    },
    skip: !orgId,
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    let isMounted = true;

    if (data && isMounted) {
      if (data.validateGoogleOAuthCredentials) {
        setGoogleOAuthStatus(data.validateGoogleOAuthCredentials);
      } else {
        setGoogleOAuthStatus(null);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [data]);

  return {
    googleOAuthStatus,
    refetchGoogleOAuthStatus: refetch,
  };
};

export default PaidSearchGoogleOAuthHandler;
